import { render, staticRenderFns } from "./HotelManIndex.vue?vue&type=template&id=16053b72&scoped=true"
import script from "./HotelManIndex.vue?vue&type=script&lang=js"
export * from "./HotelManIndex.vue?vue&type=script&lang=js"
import style0 from "./HotelManIndex.vue?vue&type=style&index=0&id=16053b72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16053b72",
  null
  
)

export default component.exports